/**
 * @file moduleCatalog.ts
 * @brief Superadmin Modules catalog — platform kill switches per product.
 *
 * @author DES
 * @date 09-09-2026
 */

export type PlatformModuleKey =
  | "interpretation"
  | "notes"
  | "boardroom"
  | "medical_assessment";

export type PlatformModuleMeta = {
  key: PlatformModuleKey;
  settingKey: string;
  label: string;
  description: string;
};

export const PLATFORM_MODULES: readonly PlatformModuleMeta[] = [
  {
    key: "interpretation",
    settingKey: "INTERPRETATION_PLATFORM_ENABLED",
    label: "Interpretation",
    description:
      "Live speech-to-speech translation in the mobile app and related APIs.",
  },
  {
    key: "notes",
    settingKey: "NOTES_PLATFORM_ENABLED",
    label: "Notes",
    description: "Personal voice notes, transcription, and AI insights.",
  },
  {
    key: "boardroom",
    settingKey: "BOARDROOM_PLATFORM_ENABLED",
    label: "Meeting Intel",
    description:
      "Boardroom recording, transcripts, summaries, and action items.",
  },
  {
    key: "medical_assessment",
    settingKey: "MEDICAL_ASSESSMENT_PLATFORM_ENABLED",
    label: "Medical Assessment",
    description:
      "Medico-legal assessments, statements, and MLR report workflow.",
  },
] as const;

export function parseModuleEnabled(raw: string | undefined): boolean {
  const value = String(raw ?? "1").toLowerCase().trim();
  return !["0", "false", "no", "off", ""].includes(value);
}
